import React, {Component} from 'react';
import AllocationStateSelector from '../../components/AllocationStateSelector/AllocationStateSelector';
import AllocationDropDown from '../AllocationDropDown/AllocationDropDown';
import CustomAllocations from '../../containers/CustomAllocations/CustomAllocations';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import classes from './Allocations.css';

export const ALLOCATION_STATE_DEFAULT = "ALLOCATION_STATE_DEFAULT";
export const ALLOCATION_STATE_CUSTOM = "ALLOCATION_STATE_CUSTOM";

export class Allocations extends Component {

    updateState = (allocationType) => {

        let isDefault = this.props.isDefault;

        if (allocationType === ALLOCATION_STATE_DEFAULT) {
            isDefault = true;
        } else {
            isDefault = false;
        }

        if (this.props.updateAllocationType) {
            this.props.updateAllocationType(isDefault);
        }

    };

    render() {

        let allocationDropDown = null;
        let customAllocations = null;

        if (this.props.isDefault) {
            allocationDropDown = (<AllocationDropDown  />);

            if (this.props.allocationId !== "CHOOSE") {
                customAllocations = (<CustomAllocations editable={false} />);
            }

        } else {
            customAllocations = (<CustomAllocations editable={true} />);
        }

        return (
            <div className={classes.Allocations}>
                <AllocationStateSelector isDefault={this.props.isDefault} click={this.updateState}/>
                {allocationDropDown}
                {customAllocations}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isDefault: state.planInfo.allocation.isDefault,
        allocationId: state.planInfo.allocation.allocationId
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAllocationType: (isDefault) => dispatch({type: actionTypes.UPDATE_ALLOCATION_TYPE, isDefault: isDefault})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Allocations);


// WEBPACK FOOTER //
// ./src/containers/Allocations/Allocations.js